import {Col, Row, Layout, Divider} from "antd";
import TickerTable from "../components/TickerTable";
import CaptureRatios from "../components/CaptureRatios";
import React from "react";
import NivoPieChart from "../../../charts/nivo/NivoPieChart";


const TickersView = ({portfolio, enhancedTickers, padding=''}) => {
    console.log('enhancedTickers', enhancedTickers);
    const pieData = enhancedTickers && [...enhancedTickers].filter(x=>x.weight>0).map(
        item => ({ id: item.name, value: item.weight?.toFixed?.(2) }));
    console.log('pieData', pieData)
    return (
        <Layout style={{borderTop: '1px solid #ededed'}}>
            <Layout.Sider style={{background: "#FFF", padding: '50px 25px', borderRight: '1px solid #ededed'}} width={450}>
                <CaptureRatios upside={portfolio?.stats?.captures?.upside ?? 0} downside={portfolio?.stats?.captures?.downside ?? 0} />
                <Divider/>
                {pieData&&(
                    <div style={{height: 400, width: 400, margin: 'auto'}}>
                        <NivoPieChart data={pieData} radius={0.5}  />
                    </div>
                )}
            </Layout.Sider>
            <Layout.Content style={{padding: '10px 20px'}}>
                <TickerTable tickers={enhancedTickers} />
            </Layout.Content>
        </Layout>
    )
}

export default TickersView;